import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {TranslateModule} from '@ngx-translate/core';
import {
  ContentLoaderComponent,
  DialogCloseButtonComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent
} from '@q9elements/ui-kit/components';
import {DeleteNodeBaseDialogComponent} from './delete-node-base-dialog.component';
import {DeleteNodeBaseDialogService} from './delete-node-base-dialog.service';

const imports = [
  CommonModule,
  TranslateModule,
  MatProgressSpinnerModule,
  MatIconModule,
  MatButtonModule,
  MatDialogModule
];
const declarations = [DeleteNodeBaseDialogComponent];

@NgModule({
  imports: [
    imports,
    ContentLoaderComponent,
    DialogCloseButtonComponent,
    SecondaryButtonComponent,
    PrimaryButtonComponent
  ],
  declarations,
  exports: [...imports, DeleteNodeBaseDialogComponent],
  providers: [DeleteNodeBaseDialogService]
})
export class DeleteNodeBaseDialogModule {}

export {DeleteNodeBaseDialogComponent, DeleteNodeBaseDialogService};
